import { post } from '../index'
export default {
  // 添加活动
  presentActiveAdd (querys) {
    return post('/passenger/admin/AdminActive/activeAdd', querys)
  },
  // 添加活动
  presentDefaultSetting (querys) {
    return post('/passenger/admin/AdminActive/defaultSetting', querys)
  },
  // 活动编辑|回显
  presentActiveUpdate (querys) {
    return post('/passenger/admin/AdminActive/activeUpdate', querys)
  },
  // 活动列表
  presentActiveList (querys) {
    return post('/passenger/admin/AdminActive/activeList', querys)
  },
  // 删除活动
  presentActiveDel (querys) {
    return post('/passenger/admin/AdminActive/activeDel', querys)
  },
  // 结束活动
  presentOverTime (querys) {
    return post('/passenger/admin/AdminActive/overTime', querys)
  },
  // 领券记录
  presentCouponList (querys) {
    return post('/passenger/admin/AdminCoupon/couponList', querys)
  },
  // 送福利券数据
  presentLogList (querys) {
    return post('/passenger/admin/AdminCoupon/logList', querys)
  },
  // 领取记录详情
  presentUserCouponList (querys) {
    return post('/passenger/admin/AdminCoupon/userCouponList', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/present.js